import _ from 'lodash';
import { ToggleButtonGroup } from '@client/new/components/ToggleButtonGroup/ToggleButtonGroup';
import {
  SmartTable,
  SmartTableProps,
} from '@client/new/components/SmartTable/SmartTable';
import { CollectionsViewModel } from './collections.viewModel';

const TableWrapper = (
  p: Pick<CollectionsViewModel, 'selectedList'> & {
    smartTableProps: SmartTableProps<number>;
  },
) => {
  if (_.isEmpty(p.smartTableProps.value.rows)) {
    return (
      <div className="text-[#8F94A1]">
        This list is empty. Only {p.selectedList} programs will appear here.
      </div>
    );
  }
  return <SmartTable {...p.smartTableProps} />;
};

export const Collections = (
  p: Pick<CollectionsViewModel, 'selectedList' | 'dispatch' | 'listOptions'> & {
    smartTableProps: SmartTableProps<number>;
  },
) => (
  <div className="flex flex-col gap-6">
    <ToggleButtonGroup
      toStringValue={(v) => `${v}`}
      toValue={(v) => v as CollectionsViewModel['selectedList']}
      value={p.selectedList}
      onChange={(e, payload) => p.dispatch({ type: 'selectList', payload })}
      options={p.listOptions}
      buttonSx={{
        border: 'none',
        borderRadius: 0,
        color: '#2C3548',
        '&.Mui-selected': {
          borderBottom: 'solid 2px black',
          background: 'inherit',
        },
        '&:hover': {
          color: '#2C3548',
        },
      }}
      groupSx={{
        borderRadius: 0,
      }}
    />
    <TableWrapper {...p} />
  </div>
);
